(function () {
    'use strict';

    angular.module("imApp").factory("consignmentPlanningService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 407,
                    parameters: parms || {}
                });
            },
            listDeliveryMethods: function (parms) {
                return $ihttp.post({
                    method: 399,
                    parameters: parms || {}
                });
            },
            listDeliveryWeeks: function (parms) {
                return $ihttp.post({
                    method: 408,
                    parameters: parms || {}
                });
            },
            listConsignmentPlans: function (parms) {
                return $ihttp.post({
                    method: 410,
                    parameters: parms || {}
                });
            },
            listConsignmentPlanning: function (parms) {
                return $ihttp.post({
                    method: 400,
                    parameters: parms || {}
                });
            },
            addSelectedOrders: function (mergeObj) {
                return $ihttp.post({
                    method: 411,
                    parameters: mergeObj
                });
            },
            removePlans: function (mergeObj) {
                return $ihttp.post({
                    method: 412,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
